"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEligTextEmpty = void 0;
var _lodash = require("lodash");
var _constants = require("./constants");
var isEligTextEmpty = exports.isEligTextEmpty = function isEligTextEmpty(eligibility_text) {
  return (0, _lodash.isEmpty)(eligibility_text) || eligibility_text === _constants.EMPTY_DRAFT_FIELD;
};